module.exports = " <table class=\"table table-responsive table-hover admin-table\"> <thead> <tr> <th>N°</th> <th>Nombre</th> <th>Email</th> <th></th> </tr> </thead> <tbody> <tr class=clickable-row v-for=\"item in list\"> <td> 1 </td> <td> <a v-link=\"{ path: '/admin/form' }\" data-href=/admin/form>1</a> </td> <td>2</td> <td> <i class=\"fa fa-trash\" aria-hidden=true></i> </td> </tr> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin-table-newsletter.vue
// module id = 541
// module chunks = 0